import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";
import { environment } from "src/environments/environment";
import {
  PropertySavedFilterModel,
  PropertySavedFilterPayload,
  PropertySavedFilterResource,
} from "../models/property-saved-filter.model";

@Injectable({
  providedIn: "root",
})
export class PropertySavedFiltersService {
  constructor(private http: HttpClient) {}

  getAll(
    resource: PropertySavedFilterResource,
  ): Observable<PropertySavedFilterModel[]> {
    const params = new HttpParams().set("resource", resource);

    return this.http
      .get<PropertySavedFilterModel[]>(
        `${environment.apiUrl}/property-saved-filters`,
        { params, withCredentials: true },
      )
      .pipe(first());
  }

  create(data: {
    resource: PropertySavedFilterResource;
    name: string;
    filters: PropertySavedFilterPayload;
    isDefault?: boolean;
  }): Observable<PropertySavedFilterModel> {
    return this.http
      .post<PropertySavedFilterModel>(
        `${environment.apiUrl}/property-saved-filters`,
        data,
        { withCredentials: true },
      )
      .pipe(first());
  }

  update(
    id: string,
    data: Partial<{
      name: string;
      filters: PropertySavedFilterPayload;
      isDefault: boolean;
    }>,
  ): Observable<PropertySavedFilterModel> {
    return this.http
      .patch<PropertySavedFilterModel>(
        `${environment.apiUrl}/property-saved-filters/${id}`,
        data,
        { withCredentials: true },
      )
      .pipe(first());
  }

  setDefault(id: string): Observable<PropertySavedFilterModel> {
    return this.http
      .patch<PropertySavedFilterModel>(
        `${environment.apiUrl}/property-saved-filters/${id}/default`,
        {},
        { withCredentials: true },
      )
      .pipe(first());
  }

  delete(id: string): Observable<{ success: boolean }> {
    return this.http
      .delete<{ success: boolean }>(
        `${environment.apiUrl}/property-saved-filters/${id}`,
        { withCredentials: true },
      )
      .pipe(first());
  }
}
